'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    _extends({ viewBox: '0 0 60 40' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('path', { fill: '#60C1ED', d: 'M60,35c0,2.75-2.25,5-5,5H5c-2.75,0-5-2.25-5-5V5c0-2.75,2.25-5,5-5h50c2.75,0,5,2.25,5,5V35z' }),
        _react2.default.createElement('path', { fill: '#5DBBE6', d: 'M58.531,1.469C59.438,2.375,60,3.625,60,5v15v15c0,1.375-0.562,2.625-1.469,3.531 C57.624,39.438,56.375,40,55,40H30H5c-1.375,0-2.625-0.562-3.531-1.469L58.531,1.469z' }),
        _react2.default.createElement(
          'g',
          null,
          _react2.default.createElement('path', { fill: '#FFFFFF', d: 'M17.555,24.922l-0.457-1.74h-3.015l-0.47,1.74h-2.755l3.028-9.318h3.346l3.064,9.318H17.555z M16.578,21.125l-0.4-1.523c-0.094-0.338-0.206-0.775-0.34-1.313c-0.133-0.538-0.221-0.923-0.264-1.155 c-0.037,0.216-0.113,0.571-0.225,1.066c-0.112,0.495-0.361,1.471-0.746,2.926L16.578,21.125L16.578,21.125z' }),
          _react2.default.createElement('path', { fill: '#FFFFFF', d: 'M25.344,24.922l-1.897-6.685h-0.058c0.089,1.138,0.133,2.022,0.133,2.654v4.03h-2.221V15.64h3.338 l1.938,6.59h0.051l1.897-6.59h3.346v9.281h-2.305v-4.069c0-0.211,0.004-0.444,0.01-0.704c0.006-0.259,0.035-0.891,0.086-1.898 h-0.058l-1.872,6.672H25.344L25.344,24.922z' }),
          _react2.default.createElement('path', { fill: '#FFFFFF', d: 'M39.119,24.922h-5.51v-9.281h5.51v2.013h-3.004v1.46h2.781v2.012h-2.781v1.752h3.004V24.922z' }),
          _react2.default.createElement('path', { fill: '#FFFFFF', d: 'M49.104,24.922h-2.899l-1.812-2.9l-1.789,2.9h-2.838l3.078-4.748l-2.895-4.533h2.781l1.676,2.869 l1.61-2.869h2.863l-2.938,4.729L49.104,24.922z' })
        ),
        _react2.default.createElement(
          'g',
          null,
          _react2.default.createElement('path', { fill: '#FFFFFF', d: 'M17.555,24.922l-0.457-1.74h-3.015l-0.47,1.74h-2.755l3.028-9.318h3.346l3.064,9.318H17.555z M16.578,21.125l-0.4-1.523c-0.094-0.338-0.206-0.775-0.34-1.313c-0.133-0.538-0.221-0.923-0.264-1.155 c-0.037,0.216-0.113,0.571-0.225,1.066c-0.112,0.495-0.361,1.471-0.746,2.926L16.578,21.125L16.578,21.125z' }),
          _react2.default.createElement('path', { fill: '#FFFFFF', d: 'M25.344,24.922l-1.897-6.685h-0.058c0.089,1.138,0.133,2.022,0.133,2.654v4.03h-2.221V15.64h3.338 l1.938,6.59h0.051l1.897-6.59h3.346v9.281h-2.305v-4.069c0-0.211,0.004-0.444,0.01-0.704c0.006-0.259,0.035-0.891,0.086-1.898 h-0.058l-1.872,6.672H25.344L25.344,24.922z' }),
          _react2.default.createElement('path', { fill: '#FFFFFF', d: 'M39.119,24.922h-5.51v-9.281h5.51v2.013h-3.004v1.46h2.781v2.012h-2.781v1.752h3.004V24.922z' }),
          _react2.default.createElement('path', { fill: '#FFFFFF', d: 'M49.104,24.922h-2.899l-1.812-2.9l-1.789,2.9h-2.838l3.078-4.748l-2.895-4.533h2.781l1.676,2.869 l1.61-2.869h2.863l-2.938,4.729L49.104,24.922z' })
        ),
        _react2.default.createElement('path', { fill: '#57B1D9', d: 'M30,0' })
      ),
      _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('path', { fill: '#9CCEDF', d: 'M55,1c2.206,0,4,1.794,4,4v30c0,2.206-1.794,4-4,4H5c-2.206,0-4-1.794-4-4V5c0-2.206,1.794-4,4-4H55 M55,0 H5C2.25,0,0,2.25,0,5v30c0,2.75,2.25,5,5,5h50c2.75,0,5-2.25,5-5V5C60,2.25,57.75,0,55,0L55,0z' })
      )
    )
  );
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=Icon_AmericanExpress.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/material-ui-credit-card-icons/lib/Icon_AmericanExpress.js
// module id = 1075
// module chunks = 0